import React from 'react'
import { Button } from '@mobi/component-library/Base/Buttons'
import { isReactNativeApp } from '@mobi/web-native-comms/web'
import { getLastKnownLocationAsString } from '@core/NativeServices/Location/LocationService'
import { get } from '@core/Services/ApiService'
import { ExpandableToolboxSection } from './Common/ExpandableToolboxSection'

type VenueLocation = {
  Venue: string
  Location: number
  GpsVenue: string
  GpsLocation: number
  SecondaryProviderCode: string
  IsGpsVenueLocationSet: boolean
}

export const GeoLocation = () => {
  const [lastKnownLocation, setLastKnownLocation] = React.useState('Unknown')
  const [lastKnownLocationTimestamp, setLastKnownLocationTimestamp] = React.useState(new Date())
  const [currentVenueLocation, setCurrentVenueLocation] = React.useState('Unknown')
  const [currentVenueLocationTimestamp, setCurrentVenueLocationTimestamp] = React.useState(
    new Date()
  )

  const updateLastKnownLocation = async () => {
    const lastKnownLocationString = getLastKnownLocationAsString()
    setLastKnownLocation(lastKnownLocationString)
    setLastKnownLocationTimestamp(new Date())
  }

  const getCurrentVenueLocation = async () => {
    const url = `webapi/device/GetCurrentVenueLocation`
    const data = await get<VenueLocation>({ url })
    let text = `${data.Venue}/${data.Location} -> GPS: `
    text += data.IsGpsVenueLocationSet ? `${data.GpsVenue}/${data.GpsLocation}/` : 'none'
    setCurrentVenueLocation(text)
    setCurrentVenueLocationTimestamp(new Date())
  }

  return (
    <ExpandableToolboxSection heading='GPS And Location' icon='DuocolorMarkerPin04'>
      <p>
        <Button size='xs' onClick={updateLastKnownLocation} disabled={!isReactNativeApp}>
          Get GPS Coords
        </Button>
      </p>
      <p>
        GPS Coords: <span>{lastKnownLocation}</span>
        <br />
        <span>Updated {lastKnownLocationTimestamp.toLocaleString()}</span>
      </p>

      <hr />

      <p>
        <Button size='xs' onClick={getCurrentVenueLocation}>
          Get Venue/Location
        </Button>
      </p>
      <p>
        Current Venue/Location: <span>{currentVenueLocation}</span>
        <br />
        <span>Updated {currentVenueLocationTimestamp.toLocaleString()}</span>
      </p>
    </ExpandableToolboxSection>
  )
}
